// extracted by mini-css-extract-plugin
export default {"modalContent":"SendPalletsWithWrongAddressesWarningModal_modalContent__Zc0x+"};